import useFileUpload, { generatePublicUrl, ProcessedFile } from "./useFileUpload";
import { StoragePathType } from "../graphql/generated/graphql";
import { useAppConfig } from "../AppConfigProvider";

export default function useEditorImageUpload(editorRef) {
  const { currentDomain } = useAppConfig();
  const { handleFileUpload } = useFileUpload({
    storagePath: StoragePathType.Resources,
    beforeUpload: () => console.log("Uploading image..."),
    afterUpload: (processedFilesArray: ProcessedFile[]) => {
      for (const processedFile of processedFilesArray) {
        const publicUrl = generatePublicUrl(currentDomain, processedFile.file.filePath);

        editorRef.current?.insertHTML(
          `<img src="${publicUrl}" style="max-width:100%; height:auto; display:block; margin:0 auto;" />`
        );
      }
    },
    onError: (msg) => console.error("Image upload failed:", msg),
    isPublic: true,
  });

  return { handleFileUpload };
}
